import React from 'react'
import classnames from 'classnames'

import enhancers from './enhancers'

export function DraggablePart(props) {
  const { children, connectDragSource, isDragging, theme, position } = props

  const className = classnames(theme.draggablePart, {
    [theme.dragging]: isDragging
  })

  return connectDragSource(
    <div className={className} style={position}>
      {children}
    </div>
  )
}

export default enhancers(DraggablePart)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/DraggablePart/index.js